import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold } from "../../common/common-text";
import { useEffect, useState } from "react";
import BTBox from "../../common/components/BTBox";
import { BTSelectBox } from "../../common/components/BTSelectBox";
import { BTDateComponent } from "../../common/components/BTDateComponent";
import { BTCheckBox } from "../../common/components/BTCheckBox";
import BTReader from "../../common/components/board/BTReader";
import { dialogStore } from "../../store/DialogStore";
import { requestDeleteAllFiles, requestDeleteRecruitDocuments } from "../../service/BoardService";
import Divider from "@mui/material/Divider";
import theme from "../../common/theme";
import { formatDateToYMD } from "../../common/utils/DateUtils";

const RecruitBoardDetail = () => {
    return (
        <MainLayout>
            <RecruitBoardDetailBody />
        </MainLayout>
    );
};

export default RecruitBoardDetail;

const RecruitBoardDetailBody = observer(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const [recruit, setRecruit] = useState<any>(null);
    const [recruitTypeOptions, setRecruitTypeOptions] = useState<{ label: string; value: string }[]>([]);

    useEffect(() => {
        const stateRecruit = location.state as any;
        if (stateRecruit?.recruit) {
            setRecruit(stateRecruit.recruit);
        }
        if (stateRecruit?.recruitTypeOptions) {
            setRecruitTypeOptions(stateRecruit.recruitTypeOptions);
        }
    }, [location.state]);

    const handleEdit = () => {
        if (!recruit) return;
        navigate("/board/recruit/edit", {
            state: {
                recruit,
                recruitTypeOptions,
            },
        });
    };

    const handleDelete = async () => {
        if (!recruit) return;

        const deleteConfirmed = await dialogStore.showAsyncDialog({
            title: "경고",
            message: "현재 채용공고를 정말로 삭제하시겠습니까?",
            isCaution: true,
        });

        if (!deleteConfirmed) return;

        try {
            await requestDeleteRecruitDocuments([recruit.id]);
            await requestDeleteAllFiles("recruit", recruit.id);

            dialogStore.showDialog({
                title: "삭제 완료",
                message: "채용공고가 삭제되었습니다.",
                onConfirm: handleBack,
                onClose: handleBack,
            });
        } catch (e) {
            console.error("채용공고 삭제 실패", e);
            dialogStore.showDialog({
                title: "오류",
                message: "채용공고 삭제 중 오류가 발생했습니다.",
                onConfirm: () => {},
                onClose: () => {},
            });
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (!recruit) return null;

    return (
        <VerticalLayout height={"auto"} paddingLeft={36} paddingRight={36}>
            {/* 상단 타이틀 */}
            <TitleLargeMedium>채용 공고 상세</TitleLargeMedium>
            <BTBox height="24px" />
            <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

            <VerticalLayout height={"auto"} paddingBottom={36}>
                {/* 정보 섹션 타이틀 */}
                <TitleMediumBold style={{ marginTop: "20px" }}>채용 공고 정보</TitleMediumBold>
                <BTBox height="16px" />

                {/* 한 줄 레이아웃: 채용 유형 | 시작 | 종료 | 공개 여부 */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        flexWrap: "nowrap",
                        fontSize: "14px",
                        color: "#6C757D",
                    }}
                >
                    <b style={{ whiteSpace: "nowrap" }}>채용 유형</b>
                    <div style={{ width: 260, flex: "0 0 auto" }}>
                        <BTSelectBox
                            value={recruit.jobType}
                            readOnly
                            options={recruitTypeOptions}
                            onChange={() => {}}
                        />
                    </div>
                </div>

                <BTBox height="16px" />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        flexWrap: "nowrap",
                        fontSize: "14px",
                        color: "#6C757D",
                    }}
                >
                    <b style={{ whiteSpace: "nowrap" }}>채용 시작 일자</b>
                    <div>{formatDateToYMD(recruit.recruitStartDate)}</div>
                    <Divider orientation="vertical" flexItem sx={{ borderColor: "#6C757D", mx: "4px" }} />

                    <b style={{ whiteSpace: "nowrap" }}>채용 종료 일자</b>
                    <div>{recruit.recruitEndDate ? formatDateToYMD(recruit.recruitEndDate) : '-'}</div>
                    <Divider orientation="vertical" flexItem sx={{ borderColor: "#6C757D", mx: "4px" }} />

                    <b style={{ whiteSpace: "nowrap" }}>글 공개 여부</b>
                    <div>{recruit.isPublished ? "✅" : "❌"}</div>
                </div>

                <BTBox height="16px" />
                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                {/* 컨텐츠 섹션 타이틀 */}
                <TitleMediumBold style={{ marginTop: "20px" }}>채용 공고 컨텐츠 정보</TitleMediumBold>
                <BTBox height="16px" />

                {/* BTReader 전폭 */}
                <div style={{ width: "100%" }}>
                    <BTReader
                        title={recruit.jobTitle}
                        contents={recruit.contents}
                        attachedFiles={recruit.attachedFiles || []}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onBack={handleBack}
                    />
                </div>
            </VerticalLayout>
        </VerticalLayout>
    );
});